import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom'; // Import context hook
import '../styles/IllustrationsGrid.scss';

// Dynamically import all images
const importAll = (requireContext) =>
  requireContext.keys().map(requireContext);

const illustrationImages = importAll(
  require.context('../assets/illustration_images', false, /\.(png|jpe?g|svg)$/)
);

function IllustrationsGrid() {
  const [selectedImage, setSelectedImage] = useState(null);

  // Access handleLightboxState from Layout's Outlet context
  const { handleLightboxState } = useOutletContext();

  const handleImageClick = (image) => {
    setSelectedImage(image); // Open lightbox with selected image
    handleLightboxState(true); // Notify Layout that lightbox is open
  };

  const closeLightbox = () => {
    setSelectedImage(null); // Close lightbox
    handleLightboxState(false); // Notify Layout that lightbox is closed
  };

  return (
    <div>
      <div className="illustrations-grid">
        {illustrationImages.map((image, index) => (
          <div
            key={index}
            className="illustrations-item"
            onClick={() => handleImageClick(image)}
          >
            <img src={image} alt={`Illustration ${index + 1}`} />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={closeLightbox}>
              &times;
            </button>
            <img src={selectedImage} alt="Selected Illustration" />
          </div>
        </div>
      )}
    </div>
  );
}

export default IllustrationsGrid;
